import {
  Component,
  EventEmitter,
  HostBinding,
  Input,
  OnDestroy,
  OnInit,
  Optional,
  Output,
  Self,
} from '@angular/core';
import { NgControl } from '@angular/forms';
import {
  ControlValueAccessor,
  FormBuilder,
  FormControl,
  FormGroup,
} from '@ngneat/reactive-forms';
import { Observable } from 'rxjs';

import { Attachment } from '@digital-platform/attachments/domain';
import {
  AttachmentUploadFacadeService,
  AttachmentValidatorService,
} from '@digital-platform/attachments/services';
import {
  FileUploadService,
  FileValidatorService,
  NestedFormComponent,
} from '@digital-platform/shared/ui';

interface Form {
  stateAttachment: FormControl<Attachment>;
}

@Component({
  selector: 'digital-platform-state-attachments-form',
  templateUrl: './state-attachments-form.component.html',
  styleUrls: ['./state-attachments-form.component.scss'],
  providers: [
    { provide: FileUploadService, useClass: AttachmentUploadFacadeService },
    { provide: FileValidatorService, useClass: AttachmentValidatorService },
  ],
})
export class StateAttachmentsFormComponent
  extends NestedFormComponent<Attachment, Form>
  implements OnInit, OnDestroy, ControlValueAccessor<Attachment>
{
  @HostBinding() class = 'digital-platform-state-attachments-form';
  @Output() public stateAttachmentDeleted = new EventEmitter<Attachment>();

  public form: FormGroup<Form>;

  constructor(
    @Optional() @Self() public controlDir: NgControl,
    private fb: FormBuilder
  ) {
    super(controlDir);
  }

  public ngOnInit() {
    let stateAttachment: Attachment;

    if (this.value) {
      stateAttachment = this.value;
    }

    if (this.form) {
      this.form.patchValue(
        { stateAttachment },
        {
          emitEvent: false,
        }
      );
    } else {
      this.form = this.fb.group({
        stateAttachment: [stateAttachment],
      });
    }

    super.ngOnInit();
  }

  public mapOutputValue(value): Attachment {
    if (!value) {
      return null;
    }

    return value?.stateAttachment;
  }

  public onFileDelete(fileData) {
    this.stateAttachmentDeleted.emit(fileData);
  }
}
